'use strict'

class GroupOverviewCtrl {

    constructor ($scope, $rootScope, $http, $state, Group, $mdDialog, $mdToast, paginationService, $transitions) {

        // Dependencies
        this.$http = $http
        this.$state = $state
        this.$mdDialog = $mdDialog
        this.$mdToast = $mdToast
        this.paginationService = paginationService
        this._Group = Group

        // Paginator
        this.pagination = {
            current: 1
        }

        // Watchers
        $rootScope.checkActive = (group) => {
            return group.id == $state.params.id
        }

        let unregister = $transitions.onSuccess({}, function (transition) {

            let toState = transition.to()
            if (toState.name === 'group') {
                this.fetch()
            }
        })

        $scope.$on('$destroy', () => {
            unregister()
        })

        // Fetch overview items
        this.fetch(1)
    }

    fetch (pageNumber) {
        this.$http.get('/groups?page=' + pageNumber)
            .then((response) => {
                this.groups = response.data.data
                this.totalResults = response.data.total
                this.resultPerPage = response.data.per_page
            })

        // this.pageChanged = function(newPage) {
        // 	getResultsPage(newPage);
        // };
    }

    // listUsers(group) {
    //     let userList = []
    //
    //     group.users.map((user) => (
    //         userList.push(user.firstname+' '+user.lastname)
    //     ))
    //
    //     return userList.join(", ")
    // }

    destroy (id, name, ev) {

        ev.stopPropagation()

        this.$mdDialog.show({

            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirmDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true
        }).then(() => {

            this._Group.delete({ id: id }, () => {
                this.fetch(this.pagination.current)
                // this.fetch(this.paginationService.getCurrentPage('__default'));
            })

            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.delete?object=group&title=' + name, //@trans('labels.group')
                hideDelay: 3000,
                position: ('top right')
            })

            this.$state.go('groups')
        })
    }
}

GroupOverviewCtrl.$inject = ['$scope', '$rootScope', '$http', '$state', 'Group', '$mdDialog', '$mdToast', 'paginationService', '$transitions']

module.exports = GroupOverviewCtrl
